<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:40px;">About the Author</h1>
<p>Susie Polzin has been doing palmistry for almost forty years and has condensed her findings into this easy-to-read guide so that people may use it as a tool to help themselves and others, and to understand how it may enhance their lives to better their chances at happiness and success.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5579b900